const bearhouseset = {
  เซตเคอร์ฟิวสุดฮิต: [34067, 34067, 34065, 34061, 34061, 34057, 34056],
  เซตเคอร์ฟิวนม: [34064, 34065, 34065, 34061, 34061],
  เซตเคอร์ฟิวชา: [34067, 34067, 34063, 34061, 34061, 34061],
  'เซตโมจิโรลบ้านหมี 3 สหาย': [34057, 34056, 34055],
  'เซตเคอร์ฟิวสุดฮิต+แป้งไข่มุกโมจิ D.I.Y': [
    34067,
    34067,
    34065,
    34061,
    34061,
    34057,
    34056,
    34268
  ],
  'เซตชานมบ้านหมี + แป้งไข่มุกโมจิ D.I.Y': [34067, 34067, 34067, 34268],
  'เชตไข่มุกบุกบ้านหมี x3': [34061, 34061, 34061],
  เชตไข่มุกบุกคาราเมลไหม้: [34061, 34061, 34061],
  เซตชาพีชบ้านหมี: [39874, 39874, 34067, 34061, 34061, 34057, 34056],
  'เชต DUO พุดดิ้ง': [47421, 48956],
  'เชต ตัว TOP สุดคุ้ม': [
    34067,
    34067,
    34063,
    34064,
    45723,
    34057,
    34056,
    34061,
    34061,
    34061,
    34061,
    47421,
    48956
  ],
  'เชต ตัว TOP บ้านหมี': [
    34067,
    34067,
    34063,
    34064,
    45723,
    34057,
    34061,
    34061,
    34061,
    34061,
    47421
  ],
  'เชต ชานมไข่มุกบ้านหมี': [34067, 34067, 34067, 34064, 34063, 45723, 34061, 34061, 34061],
  เชตชานมขนมเหมือนฝัน: [
    34067,
    34067,
    34063,
    34064,
    45723,
    73684,
    73683,
    34061,
    34061,
    34061,
    34061,
    34061
  ],
  เชตชานมขนมบ้านหมี: [
    34067,
    34067,
    34063,
    34064,
    45723,
    45723,
    34057,
    34056,
    73684,
    73683,
    34061,
    34061,
    34061,
    34061,
    34061
  ],
  เชตเหมือนฝันสุดคุ้ม: [34067, 34063, 34064, 45723, 73684, 73683, 34061, 34061, 34061],
  'เชตเหมือนฝัน A': [34067, 34063, 34064, 45723, 73683, 73684, 34061, 34061, 34061],
  'เชตเหมือนฝัน B': [
    34067,
    34067,
    34063,
    34064,
    45723,
    73684,
    73683,
    34061,
    34061,
    34061,
    34061,
    34061
  ],
  'เชตเหมือนฝัน C': [
    34067,
    34067,
    34063,
    34064,
    45723,
    45723,
    34057,
    34056,
    73684,
    73683,
    34061,
    34061,
    34061,
    34061,
    34061
  ]
}

// 34059

// ชานมบ้านหมีหน้าร้าน 34067
// ช็อกโกแลตบ้านหมี 34064
// ชาไทยบ้านหมีปักษ์ใต้ 34063
// ไข่มุกบุกคาราเมลไหม้ 34061
// โมจิโรลนมฮอกไกโด 34057
// โมจิโรลช็อกโกแลต 34056
// โมจิโรลฝอยทองบ้านหมี 34055
// แป้งไข่มุกโมจิบ้านหมี D.I.Y 34268
// นมน้ำตาลแดงบ้านหมี 34065
// ชาพีชบ้านหมี 39874
// เซ็ทชาพีชบ้านหมี 39816
// ชาดำยูซุบ้านหมี 45723
// เหมือนฝัน เปี๊ยะโมจิไก่หยอง 73684
// เหมือนฝัน เปี๊ยะโมจิไข่เค็ม 73683

// พุดดิ้งสุขเย็นนมละมุน	47421
// พุดดิ้งสุขเย็นช็อกละมุน	48956

export { bearhouseset }



// WEBPACK FOOTER //
// ./src/bearhouse.js